import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button } from "antd";
import { FilePdfOutlined } from "@ant-design/icons";
import ticketsActions from "../../redux/ticket/actions";
import arrowImage from "../../images/right-arrow.png";
import { epochToNormalDate, convertToEuro } from "../../utils/utility";
import "./index.css";
import { t } from "i18next";
const Cell = (props) => {
  const {
    tickets: {
      ticketNumber,
      place,
      fromName,
      fromNameLng,
      toName,
      toNameLng,
      typeName,
      startTime,
      endTime,
      email,
      forPerson,
      sektor,
      price,
    },
  } = props;
  const dispatch = useDispatch();
  const [active, handleActive] = useState(false);
  const {
    token,
    companies,
    companiesDetails,
    selectedLanguage,
    showEuroPrice,
  } = useSelector((state) => state.mainReducer);

  const { getTicketPDF } = ticketsActions;
  const checkFromName = selectedLanguage === "bg" ? fromName : fromNameLng;
  const checkToName = selectedLanguage === "bg" ? toName : toNameLng;

  return (
    <div
      className="order-history-card-container"
      style={{
        height: active ? `300px` : `100px`,
      }}
    >
      <div
        className="order-history-card-first-column"
        onClick={() => {
          handleActive(!active);
        }}
      >
        <div className="order-history-card-row">
          <div
            className="order-history-card-row-text"
            style={{ fontWeight: "bold", color: "rgb(13, 28, 83)" }}
          >
            {t("from")}
          </div>
          {checkFromName}
        </div>
        <div
          className="order-history-card-row"
          style={{
            marginTop: "15px",
          }}
        >
          <img alt="arrow" style={{ width: "30px" }} src={arrowImage} />
        </div>
        <div className="order-history-card-row">
          <div
            className="order-history-card-row-text"
            style={{ fontWeight: "bold", color: "rgb(13, 28, 83)" }}
          >
            {t("to")}
          </div>
          {checkToName}
        </div>
      </div>
      <div
        className="order-history-card-row-detail-first"
        style={{
          transform: active
            ? `rotate3d(1, 0, 0, -180deg)`
            : `rotate3d(1, 0, 0, 0deg)`,
          transitionDelay: active ? "0s" : "0.3s",
        }}
      >
        <div
          className="order-history-card-row-detail-first-top"
          onClick={() => {
            handleActive(!active);
          }}
        >
          <img
            alt="logo"
            className="order-history-card-logo"
            src={`data:image/jpeg;base64,${companiesDetails?.logo}`}
          />

          <div className="order-history-card-row-detail-time-container">
            <div className="order-history-card-row-detail-date">
              {checkFromName}
              <div className="order-history-card-row-detail-time">
                {checkFromName?.substring(0, 7)}
              </div>
              {epochToNormalDate(startTime)}
            </div>
            <img
              alt="arrow"
              style={{
                width: "30px",
                height: "26px",
                marginTop: "22px",
                marginLeft: "16px",
                marginRight: "16px",
              }}
              src={arrowImage}
            />
            <div className="order-history-card-row-detail-date">
              {checkToName}
              <div className="order-history-card-row-detail-time">
                {checkToName?.substring(0, 7)}
              </div>
              {epochToNormalDate(endTime)}
            </div>
          </div>
        </div>
        <div className="order-history-card-behind">
          <div className="order-history-card-behind-display">
            <div className="order-history-card-row-behind">
              <div className="order-history-card-row-detail">
                {t("name")}
                <div className="order-history-card-row-text">{forPerson}</div>
              </div>
              <div className="order-history-card-row-detail">
                {t("email")}
                <div className="order-history-card-row-text">{email}</div>
              </div>
            </div>

            <div className="order-history-card-row-behind">
              <div className="order-history-card-row-detail">
                {t("sector")}
                <div className="order-history-card-row-text">{sektor}</div>
              </div>
              <div className="order-history-card-row-detail">
                {t("place")}
                <div className="order-history-card-row-text">{place}</div>
              </div>
            </div>
          </div>
          <div
            className="order-history-card-row-detail-second"
            style={{
              transform: active
                ? `rotate3d(1, 0, 0, -180deg)`
                : `rotate3d(1, 0, 0, 0deg)`,
              transitionDelay: active ? "0.2s" : "0.2s",
            }}
          >
            <div className="order-history-card-row-detail-second-top" />
            <div className="order-history-card-row-detail-second-behind">
              <div className="order-history-card-row-detail-second-display">
                <div className="order-history-card-row-detail-second-display-price">
                  {typeName}
                </div>
                <div>
                  <span>
                    {price?.toFixed(2)} €
                  </span>
                  {showEuroPrice && (
                    <>
                      <span> / </span>
                      <span>{convertToEuro(price)?.toFixed(2)} {t("lv")}</span>
                    </>
                  )}
                </div>
              </div>
              <div
                className="order-history-card-row-detail-third"
                style={{
                  transform: active
                    ? `rotate3d(1, 0, 0, -180deg)`
                    : `rotate3d(1, 0, 0, 0deg)`,
                  transitionDelay: active ? "0.4s" : "0s",
                }}
              >
                <div className="order-history-card-row-detail-third-top" />
                <div className="order-history-card-row-detail-second-behind-bottom">
                  <Button
                    type="text"
                    style={{
                      width: "90%",
                      background: "#e6e6e6",
                    }}
                    onClick={() => {
                      dispatch(
                        getTicketPDF(token, companies[0]?.id, ticketNumber)
                      );
                    }}
                    icon={<FilePdfOutlined />}
                    size="large"
                  >
                    {t("downloadTicket")}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const OrderHistory = () => {
  const storedTickets = localStorage.getItem("createdTickets");
  let createdTickets = [];

  if (storedTickets) {
    try {
      createdTickets = JSON.parse(storedTickets);
    } catch (error) {}
  }

  return (
    <>
      <div className="order-history-main-container">
        <div className="order-history-container">
          {createdTickets?.reverse()?.map((ticket, i) => (
            <Cell key={i} tickets={ticket} />
          ))}
        </div>
      </div>
    </>
  );
};
export default OrderHistory;
